import appAxios from "./axios";
/*
    For CRUD
*/
export class AuthService {
  static createUser(data) {
    return appAxios.post("/auth/signup", data);
  }

  static login(user) {
    return appAxios.post("/auth/sign", user);
  }

  static loginWithPhone(phone, password) {
    return appAxios.post("/auth/phone/sign", { phone, password });
  }

  // Демо-доступ: регистрация компании с пробным периодом.
  // Код подтверждения сначала отправляется через whatsappService.singin(phone)
  static trialSignup({ name, phone, password, orgName, code }) {
    return appAxios.post("/auth/trial-signup", { name, phone, password, orgName, code });
  }

  static signInWithGoogle(user, accessToken) {
    return appAxios.post("/auth/google", {
      user,
      accessToken,
    });
  }
}
